import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const dialogStyles = makeStyles({
  root: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 850,
    }
  }
});

const Modal = ({ description, handleClose, open, title }) => {
  const classes = dialogStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableScrollLock={true}
      className={title === "Locations" ? classes.root : ""}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
          </Button>
      </DialogActions>
    </Dialog>
  )
};

export default Modal;